import BaseItemId from 'owa-service/lib/contract/BaseItemId';
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import respondToCalendarEventOperation from 'owa-service/lib/operation/respondToCalendarEventOperation';
import respondToCalendarEventRequest from 'owa-service/lib/factory/respondToCalendarEventRequest';
import RespondToCalendarEventResponse from 'owa-service/lib/contract/RespondToCalendarEventResponse';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { MailboxInfo } from 'owa-client-ids';
import { logServiceCallForDiagnostics } from 'owa-calendar-forms-diagnostics';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function respondToCalendarEventService(
    seriesOrSingleId: BaseItemId,
    mailboxInfo: MailboxInfo,
    response: ResponseTypeType,
    sendResponse: boolean,
    responseMessage: string = '',
    proposedStartTime: string = '',
    proposedEndTime: string = '',
    meetingMessageId: string = ''
): Promise<RespondToCalendarEventResponse> {
    const request = {
        Header: getJsonRequestHeader(),
        Body: respondToCalendarEventRequest({
            EventId: seriesOrSingleId,
            Response: response,
            SendResponse: sendResponse,
            Notes: bodyContentType({
                BodyType: 'HTML',
                Value: responseMessage,
            }),
            ProposedStartTime: proposedStartTime,
            ProposedEndTime: proposedEndTime,
            MeetingRequestIdToBeDeleted: meetingMessageId,
        }),
    };
    let serverResponse;

    try {
        serverResponse = await respondToCalendarEventOperation(
            request,
            getMailboxRequestOptions(mailboxInfo)
        );
    } finally {
        // Log the service call for forms diagnostics panel
        if (isFeatureEnabled('cal-mf-diagnostics')) {
            logServiceCallForDiagnostics({
                action: 'RespondToCalendarEvent',
                status: serverResponse ? serverResponse.Body.ResponseCode : 'Error',
                response: serverResponse?.Body,
                request: request,
            });
        }
    }

    return serverResponse?.Body;
}
